import React from 'react';
import { Navigate } from 'react-router-dom';
import SubHeader from '../../components/Layout/SubHeader';
import { Select } from 'antd';
import { getAuthToken, getUserData, storeUserData } from '../../components/Util';
import { toast } from 'react-toastify';
import axios from 'axios';
import api from '../../config/api';
import { images } from '../../config/image';
import strings from '../../components/Language';
import { ProgressBar } from 'react-loader-spinner';

class InstallerApplyScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ProgressBar: true,
            lang: strings.getLanguage(),
            access_token: null,
            userDetails: null,
            profilePic: null,
            username: null,
            errorMessage: [],
            newSkill: [],
            skill_array: [strings["specialty1"], strings["specialty2"], strings["specialty3"], strings["specialty4"]],
            gender: '1',
            company: '',
            mobile: '',
            race: '',
            exp_year: '',
            worker_count: '',
            o_tag: '',
            address: '',
            redirect: false,
            city_id: '',
            city_loading: true,
            cities: [],
        }
    }

    async componentDidMount() {
        let self = this;
        var token = await getAuthToken();

        if (token) {
            self.setState({ access_token: token });
            await storeUserData(token, this);
            setTimeout(() => {

                var userData = getUserData();
                self.setState({
                    userDetails: userData.data,
                    profilePic: userData.data.profile_url,
                    username: userData.data.username
                })

                self.setState({ ProgressBar: false });
                self.getCities(api.Cities);
            });
        }
    }

    getCities(APIURL) {
        const self = this;
        self.setState({ city_loading: true });
        axios({
            method: 'GET',
            url: APIURL,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({
                cities: (ress.data.message) ? ress.data.message : [],
                city_id: (ress.data.city_id) ? ress.data.city_id : 1,
                city_loading: false
            })
        }).catch(function (erro) {
            self.setState({ city_loading: true });
        });
    }

    handleCheckboxChange = (event) => {
        const { value, checked } = event.target;

        this.setState((prevState) => {
            const { newSkill } = prevState;

            // Add value if checked, remove value if unchecked
            if (checked) {
                return { newSkill: [...newSkill, value] };
            } else {
                return { newSkill: newSkill.filter((val) => val !== value) };
            }
        });
    };

    onPressApply() {
        const self = this;

        if (this.state.company === '') {
            toast.error(strings["namePlaceholder"]);
            return false;
        }
        if (this.state.mobile === '') {
            toast.error(strings["contactPlaceholder"]);
            return false;
        }

        if (this.state.race === '') {
            toast.error(strings["racePlaceholder"]);
            return false;
        }
        if (this.state.exp_year === '') {
            toast.error(strings["experiencePlaceholder"]);
            return false;
        }

        if (this.state.worker_count === '') {
            toast.error(strings["workerPlaceholder"]);
            return false;
        }
        self.setState({ 'isLoading': true })
        self.setState({ ProgressBar: true });
        var json = {
            mobile: self.state.mobile,
            company: self.state.company,
            gender: self.state.gender,
            race: self.state.race,
            exp_year: self.state.exp_year,
            worker_count: self.state.worker_count,
            o_tag: self.state.o_tag,
            address: self.state.address,
            s_tag: self.state.newSkill,
            lang: self.state.lang,
            city_id: self.state.city_id,
        };

        axios({
            method: 'POST',
            url: api.InstallerApply,
            data: json,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + self.state.access_token,
            }
        }).then(function (ress) {
            self.setState({ isLoading: false });
            if (ress.data.error == 202 || ress.data.error == '202') {
                if (ress.data.errors && ress.data.errors.length != 0) {
                    self.setState({ errorMessage: ress.data.errors });
                } else {
                    toast.error(ress.data.message);
                }
            } else {
                toast.success(ress.data.message);
                self.setState({ mobile: '', company: '', race: '', gender: '1', address: '', newSkill: [], exp_year: '', worker_count: '', city_id: '' });
                self.setState({ redirect: true });
                return false;
            }
            self.setState({ ProgressBar: false });
        }).catch(function (err) {
            self.setState({ 'isLoading': false });
            toast.error(strings["no_internet"]);
            self.setState({ ProgressBar: false });
        });
    }

    render() {
        if (this.state.redirect) {
            return <Navigate to="/installer" />;
        }

        return (
            <>
                <ProgressBar visible={this.state.ProgressBar} height="80" width="80" color="#f05a29" borderColor='#f05a29' barColor='#f05a29' wrapperClass="progress-bar" />
                <SubHeader data={{ title: strings["installerApply"] }} />

                <div className='installerApplyScreen'>
                    <main>
                        <div className="top-section">
                            <h1 id="applyTitle" className="installer-title">{strings["applyTitle"]}</h1>
                        </div>

                        <div className="align-form">
                            <form className="form-container">
                                <div className="info-wrap">
                                    {this.state.profilePic ?
                                        <img className="installer-profile" src={this.state.profilePic + "?ver=" + Math.random()} alt='' />
                                        :
                                        <img className="installer-profile" src={images["profile-icon"]} alt='' />
                                    }
                                    <div className="align-right">
                                        {/* <p>{strings["installerTitle"]}</p>
                                        <p>{strings["ContactNoTitle"]}</p>
                                        <p className="ratings">{strings["Overall Rating (no rating)"]}</p> */}
                                    </div>
                                </div>

                                <div className="form-content">
                                    <label id="companyLabel">{strings["companyLabel"]}<span>*</span></label>
                                    <input
                                        onChange={(e) => this.setState({ company: e.target.value })}
                                        type="text"
                                        id="namePlaceholder"
                                        placeholder={strings["namePlaceholder"]}
                                    />
                                </div>
                                <div className="form-content">
                                    <label id="contactLabel">{strings["contactLabel"]}<span>*</span></label>
                                    <input
                                        onChange={(e) => this.setState({ mobile: e.target.value })}
                                        type="tel"
                                        id="contactPlaceholder"
                                        placeholder={strings["contactPlaceholder"]}
                                    />
                                </div>
                                <div className="form-content">
                                    <label id="genderLabel">{strings["genderLabel"]}<span>*</span></label>
                                    <div className="custom-dropdown">
                                        <div id="genderChoice" className="dropdown-selected">
                                            {strings["genderChoice"]}
                                        </div>
                                        <Select defaultValue={this.state.gender} onChange={(e) => this.setState({ gender: e })} style={{ width: "100%" }}>
                                            <Select.Option value="1">{strings["maleOption"]}</Select.Option>
                                            <Select.Option value="2">{strings["femaleOption"]}</Select.Option>
                                        </Select>
                                    </div>
                                </div>
                                <div className="form-content">
                                    <label id="raceLabel">{strings["raceLabel"]}<span>*</span></label>
                                    <input onChange={(e) => this.setState({ race: e.target.value })} type="text" id="racePlaceholder" placeholder={strings["racePlaceholder"]} />
                                </div>
                                <div className="form-content">
                                    <label id="experienceLabel">{strings["experienceLabel"]}</label>
                                    <input
                                        onChange={(e) => this.setState({ exp_year: e.target.value })}
                                        type="text"
                                        id="experiencePlaceholder"
                                        placeholder={strings["experiencePlaceholder"]}
                                    />
                                </div>
                                <div className="form-content">
                                    <label id="workerLabel">{strings["workerLabel"]}</label>
                                    <input
                                        onChange={(e) => this.setState({ worker_count: e.target.value })}
                                        type="text"
                                        id="workerPlaceholder"
                                        placeholder={strings["workerPlaceholder"]}
                                    />
                                </div>
                                <div className="specialty-wrap">
                                    <label id="specialtyLabel">{strings["specialtyLabel"]}</label>
                                    {this.state.skill_array.map((item, i) =>
                                        <>
                                            <div className="specialty-selection">
                                                <input
                                                    type="checkbox"
                                                    value={item}
                                                    checked={this.state.newSkill.includes(item)}
                                                    onChange={this.handleCheckboxChange}
                                                />
                                                <span id="specialty1" style={{ marginLeft: 10 }}>{item}</span>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="form-content">
                                    <label id="otherLabel">{strings["otherLabel"]}</label>
                                    <input
                                        onChange={(e) => this.setState({ o_tag: e.target.value })}
                                        type="text"
                                        id="otherPlaceholder"
                                        placeholder={strings["otherPlaceholder"]}
                                    />
                                </div>
                                <div className="form-content">
                                    <label id="addressLabel">{strings["addressLabel"]}</label>
                                    <textarea
                                        onChange={(e) => this.setState({ address: e.target.value })}
                                        className="address-input"
                                        type="text"
                                        id="addressPlaceholder"
                                        placeholder={strings["addressPlaceholder"]}
                                    ></textarea>
                                </div>

                                <div className="form-content">
                                    <label id="cityLabel">{strings['City']}</label>
                                    <div className="custom-dropdown">
                                        <Select defaultValue={this.state.city_id} onChange={(e) => this.setState({ city_id: e })} style={{ width: "100%" }}>
                                            <Select.Option value="">{strings['SelectCity']}</Select.Option>
                                            {this.state.cities.map((item, i) => (
                                                <Select.Option key={"city_001_" + i} value={item.id} >{item.name}</Select.Option>
                                            ))}
                                        </Select>
                                    </div>
                                </div>

                                <button onClick={() => this.onPressApply()} type="button" id="submitButton" className="submit-button">
                                    {strings["submitButton"]}
                                </button>
                            </form>
                        </div>
                    </main>
                </div>
            </>
        );
    }
}

export default InstallerApplyScreen;
